import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import simplebar from "simplebar-vue";
import BaseMixer from "../../BaseMixer";
import { ILiveViewProjectModeEntryDTO } from "@/store/models/workView/liveViewProjectModeEntry";
let LiveViewProjectEntryComponent = /** @class */ (() => {
    var _a;
    let LiveViewProjectEntryComponent = class LiveViewProjectEntryComponent extends Mixins(BaseMixer) {
        workviewTooltip(value) {
            if (value != null || value != "") {
                return value.length > 23 ? value : null;
            }
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof ILiveViewProjectModeEntryDTO !== "undefined" && ILiveViewProjectModeEntryDTO) === "function" ? _a : Object)
    ], LiveViewProjectEntryComponent.prototype, "liveViewProjectModeEntry", void 0);
    LiveViewProjectEntryComponent = __decorate([
        Component({
            name: "LiveViewProjectEntryComponent",
            components: {
                simplebar,
            },
        })
    ], LiveViewProjectEntryComponent);
    return LiveViewProjectEntryComponent;
})();
export default LiveViewProjectEntryComponent;
